import Sm2Company from './company';

export default Sm2Company;
